export const bluetoothConstants={
    UPDATE_BLUETOOTH_STATUS: "UPDATE_BLUETOOTH_STATUS",
    UPDATE_ACTIVITY_STATUS: "UPDATE_ACTIVITY_STATUS",
    BLUETOOTH_CONNECTION: "CONNECTED_BLUETOOTH_DEVICE"
}